import * as React from "react";
import {cx} from "emotion";

import "./copay.scss";

import {applyResultCart} from "@APMUI/routes/checkout/common/apply-result-cart";

import {cs}                             from "@Common/react/chain-services";
import {consumeContext}                 from "@Common/react/context";
import {csArr}                          from "@Common/react/cs-arr";
import {stateChangeNestedValue}         from "@Common/react/state-change-nested-value";
import {UseState}                       from "@Common/react/use-state";
import {createCopayForm}                from "@Common/ui-components/copay-form/copay-form";
import {isDevQuan}                      from "@Common/ui-components/debug/is-dev-quan";
import {getNestedValue, setNestedValue} from "@Common/utils/arr-path";
import {unique}                         from "@Common/utils/collections";
import {chain}                          from "@Common/utils/fs";
import {BlockGuestAccess}               from "@Common/logic/block-guest-access";

import {MasterTable}  from "../../../../../common/master-table/master-table";
import {PaymentPanel} from "../../payments-section/common/payment-panel";

import {Expansion} from "./expansion/expansion";
import {apiArray} from "@Common/logic/api-array";

export const Copay = ({store, next: rootNext}) => cs(
    ["applicableOrders", (_, next) => ApplicableOrders({store, next})],
    ["blockGuestAccess", (_, next) => BlockGuestAccess({next})],
    ({applicableOrders, blockGuestAccess}, next) => rootNext({
        available: !!applicableOrders.length && !blockGuestAccess,
        render: ({className,showErrors,}) => cs(
            ["forceExpand", (_, next) => UseState({
                initValue: true,
                next
            })],
            ["status", (_, next) => UseState({next})],
            consumeContext("apis"),
            ({forceExpand, status, apis}) => {
                const open = forceExpand.value || applicableOrders.find((o) => o.applied);
                return (
                    PaymentPanel({
                        title: "Copay",
                        className: cx("copay copay-24h", className),
                        hasError: false,
                        controls: {
                            status: status.value,
                            checkbox: {
                                value: open,
                                onChange: async () => {
                                    if (open) {
                                        const appliedCopays = applicableOrders.filter((o) => o.applied);
                                        if (appliedCopays.length) {
                                            status.onChange("Removing copays");
                                            await store.dispatch(removeAllCopays({apis}));
                                            appliedCopays.forEach((o) => o.removedAllCopays());
                                            status.onChange(null);
                                        }
                                        forceExpand.onChange(false);
                                    } else {
                                        forceExpand.onChange(true);
                                        const prevCopays = applicableOrders.map((o) => o.getPrevForm()).filter(v=>v);
                                        if (prevCopays.length) {
                                            status.onChange("Reapplying copays");
                                            await store.dispatch(applyAllCopays(prevCopays, {apis}));
                                            status.onChange(null);
                                        }
                                    }
                                },
                                xdQaName: "Copay Slider",
                            },
                        },
                        content: () => open ? next() : null,
                    })
                );
            },
        ),
    }),
    ({applicableOrders}) => <>
        <div className="description">
            {chain(
                applicableOrders.map((order) => order.item.billingAvailable.copay.description).filter(v=>v),
                (_) => unique(_),
                (_) => _.map((rule, i) => (
                    <div className="line" key={i} xd-qa-type="label" xd-qa-name={rule}>
                        {rule}
                    </div>
                ))
            )}
        </div>

        <div className="table">
            {MasterTable({
                defaultExpanded: () => true,
                list: applicableOrders.map((order) => ({
                    rowId : order.item.itemId,
                    key: order.item.itemId,
                    onClick: ({expanded, setExpanded}) => setExpanded(!expanded),
                    columns: [
                        {
                            renderCell: () => order.item.itemId,
                            sortValue : () => order.item.itemId,
                            xdQaName: order.item.itemId,
                        },
                        {
                            renderCell: () => order.item.itemName,
                            sortValue : () => order.item.itemName,
                            xdQaName: order.item.itemName,
                        },
                        {

                            className: "expand-indicator",
                            renderCell: ({expanded}) => (
                                <i className={expanded ? "fa fa-chevron-up" : "fa fa-chevron-down"}/>
                            ),
                            xdQaName: "expand",
                        },
                    ],
                    renderExpansion: order.renderExpansion,
                    xdQaType: "card",
                    xdQaName: order.item.itemId,
                })),
                columns: [
                    {
                        label: "ORDER ID",
                        xdQaName: "ORDER ID",
                    },
                    {
                        label: "ORDER NAME",
                        className: "order-name",
                        xdQaName: "ORDER NAME",
                    },
                    {
                        label: "ACTIONS",
                        sorting: {
                            disabled: true,
                        },
                        align: "right",
                        xdQaName: "ACTIONS",
                    },
                ],
            })}
        </div>
    </>,
);

const ApplicableOrders = ({store, next}) => cs(
    ["orders", ({}, next) => csArr(
        store.cart.items
            .map((item) => {
                const copay = getNestedValue(item, ["billingAvailable", "copay"]);

                // if (!copay || +copay.amountAvailable === 0) {
                if (!copay) {
                    return null;
                }

                return (next) => cs(
                    ["applied", (_, next) => next(apiArray(store.cart.appliedCredits?.copays)?.find((c) => c.itemId == item.itemId))],
                    ["pending"  , ({applied}, next) => UseState({getInitValue: () => applied?.copayAddress, next})],
                    ["submitted", ({applied}, next) => UseState({getInitValue: () => applied?.copayAddress, next})],
                    ["form", ({applied}, next) => next(createCopayForm({
                        copay,
                        applied,
                    }))],
                    ({pending, submitted, form, applied}) => next({
                        item,
                        applied,
                        removedAllCopays: () => {
                            stateChangeNestedValue(pending, ["copayAdjustment"], () => null);
                        },
                        getPrevForm: () => !submitted.value ? null : {
                            itemId: item.itemId,
                            ...form.toReq(submitted.value),
                        },
                        renderExpansion: () => Expansion({
                            form,
                            onRemovedCopay: () => submitted.onChange(null),
                            itemId: item.itemId,
                            store,
                            appliedCopay: applied,
                            pending,
                            submitted,
                        }),
                    }),
                );
            })
            .filter(v=>v)
        ,
        next,
    )],
    ({orders}) => next(orders),
);

const applyAllCopays = (copays, {apis}) => ({
    action: async (cart) => {
        const resultCart = await apis.next.cart.updateCart(chain(
            {cartId: cart.cartId,},
            (_) => setNestedValue(_, ["credits", "copays"], copays),
        ));

        const errors = resultCart.paymentErrors?.copays?.find((c) => c.errors?.length)?.errors;
        if (errors?.length) {
            return {
                error: {
                    msg: errors[0],
                },
            };
        } else if (resultCart.errors?.length) {
            return {
                error: {
                    msg: resultCart.errors[0].msg,
                },
            };
        } else {
            return ({
                change: applyResultCart(resultCart),
            });
        }
    },
});

const removeAllCopays = ({apis}) => ({
    action: async (cart) => ({
        change: applyResultCart(await apis.next.cart.updateCart(chain(
            {cartId: cart.cartId},
            (_) => setNestedValue(
                _,
                ["removeCredits", "copays"],
                cart.appliedCredits.copays,
            ),
        ))),
    })
});

